import React, { PropsWithChildren } from 'react';
import { Redirect } from 'react-router-dom';
import Loader from 'components/loading/Loader';
import routeList from 'routes/routeList';
import ApiLoaderFallback from 'components/errors/ApiLoaderFallback';
import { IServerError } from 'api';

interface IProps {
  status: string;
  errorCodes?: IServerError[] | null;
}

const ApiLoader: React.FC<PropsWithChildren<IProps>> = ({ status, errorCodes, children }) => {
  switch (status) {
    case 'error':
      return errorCodes?.find((e) => e.code === 'ose-public-002') ? (
        <Redirect to={routeList.notFound} exact />
      ) : (
        <ApiLoaderFallback />
      );
    case 'fetching':
    case 'idle':
    case 'loading':
      return <Loader />;
    default:
      return <>{children}</>;
  }
};

export default ApiLoader;
